import { createContext } from "react";
const BannerSliderContext = createContext({});

export default BannerSliderContext;
